import ax from "./ax";
import axJava from "./axJava";

// 获取用户状态
export function GetUserStatus(data = {}) {
  return ax({
    url: "/app/User/GetUserStatus",
    method: "post",
    data
  });
}

// 获取帮助反馈(助手)
export function GetFaqListZs(data = {}) {
  return ax({
    url: "/app/User/GetFaqList",
    method: "post",
    data
  });
}

// 2021.12.13 优惠收款交易明细
export function GetUserPayRewardList(data = {}) {
  return ax({
    url: "/app/User/GetUserPayRewardList",
    method: "post",
    data
  });
}

// 获取帮助反馈(终端)
export function GetFaqListZd(data = {}) {
  return axJava({
    url: "/api/APPUser/GetFaqList",
    method: "post",
    data
  });
}

// 2020.8.13
export function GetUserStatistic(data = {}) {
  return axJava({
    url: "/api/APPUser/getUserStatistic",
    method: "post",
    data
  });
}

// 2020.8.13
export function RewardDetailed(data = {}) {
  return axJava({
    url: "/api/APPUser/RewardDetailed",
    method: "post",
    data
  });
}

// 2020.10.21 获取第三方邀请链接（助手）
export function GetThirdPartyInviteUrlOfZs(data = {}) {
  return ax({
    url: "/app/User/GetThirdPartyInviteUrl",
    method: "post",
    data
  });
}

// 2020.10.21 获取第三方邀请链接（终端）
export function GetThirdPartyInviteUrlOfZd(data = {}) {
  return axJava({
    url: "/api/APPUser/GetThirdPartyInviteUrl",
    method: "post",
    data
  });
}

// 2020.12.24 小恒管家-账户余额汇总(达标奖励)
export function GetUserMoneyLogBalance(data = {}) {
  return ax({
    url: "/app/User/GetUserMoneyLogBalance",
    method: "post",
    data
  });
}

// 2020.10.21 小恒管家-代理商余额明细
export function GetAgentMoneyLog(data = {}) {
  return ax({
    url: "/app/User/GetAgentMoneyLog",
    method: "post",
    data
  });
}

// 2021.5.21 风控列表 
export function GetPayTagRiskList(data = {}) {
  return axJava({
    url: "/api/APPUser/GetPayTagRiskList",
    method: "post",
    data
  });
}

// 2021.5.21 风控列表详情
export function GetPayTagRiskAuditDetail(data = {}) {
  return axJava({
    url: "/api/APPUser/GetPayTagRiskAuditDetail",
    method: "post",
    data
  });
}

// 2021.5.21 风控列表提交审核
export function UpdatePayTagRisk(data = {}) {
  return axJava({
    url: "/api/APPUser/UpdatePayTagRisk",
    method: "post",
    data
  });
}

// 2022.4.8 代理商注册
export function AgentRegister(data = {}) {
  return ax({
    url: "/app/User/AgentRegister",
    method: "post",
    data
  });
}